// src/pages/HomePage.js
import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import SocialSection from '../components/SocialSection';
import RoadmapSection from '../components/RoadmapSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <AboutSection />
      <SocialSection />
      <RoadmapSection />
      <Footer />
    </>
  );
};

export default HomePage;
